import React from 'react';
import {useIntl} from 'react-intl';
import {Table} from '@/web-components';
import MonthByMonthProgramLoader, {monthByMonthProgramLoaderQuery} from './MonthByMonthProgramLoader';
import {filtersToSearchQuery} from '../ProjectPortfolioReportUtils';
import ProjectPortfolioMonthByMonthProgramDownload, {
	projectPortfolioMonthByMonthProgramDownloadQuery,
} from './ProjectPortfolioMonthByMonthProgramDownload';
import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {LoadMore} from '../../../loaders/LoadMore';
import ProjectPortfolioMonthByMonthRow from './ProjectPortfolioMonthByMonthRow';
import ProjectPortfolioMonthByMonthProjectRows from './ProjectPortfolioMonthByMonthProjectRows';
import ProgramUtil from '../../../../forecast-app/shared/util/ProgramUtil';

const ProjectPortfolioMonthByMonthProgramRows = ({
	setCsvDownloadFunction,
	hasBaseline,
	pageSize,
	startDate,
	endDate,
	filters,
	boolEyeOptions,
	levelProps,
	timeSearchQuery,
	expenseSearchQuery,
	selectedSingleValue,
	useWinProbability,
}) => {
	const intl = useIntl();

	return (
		<LoadMore
			key="query-render-month-by-month-program"
			query={monthByMonthProgramLoaderQuery}
			variables={{
				searchQuery: filtersToSearchQuery(filters),
				timeSearchQuery: timeSearchQuery,
				expenseSearchQuery: expenseSearchQuery,
				startYear: startDate.year(),
				startMonth: startDate.month() + 1,
				startDay: startDate.date(),
				endYear: endDate.year(),
				endMonth: endDate.month() + 1,
				endDay: endDate.date(),
				pageSize: pageSize,
				selectedSingleValue: selectedSingleValue,
				ignoreBaselineWinChance: !useWinProbability,
				excludeOpportunityActuals: true,
			}}
			loader={<MonthByMonthProgramLoader />}
		>
			{({data, loadMore}) => {
				setCsvDownloadFunction(() => {
					showModal({
						type: MODAL_TYPE.DOWNLOADING_CSV_DATA,
						componentName: 'project_portfolio_month_by_month_program_csv_loader',
						query: projectPortfolioMonthByMonthProgramDownloadQuery,
						variables: {
							searchQuery: filtersToSearchQuery(filters),
							timeSearchQuery: timeSearchQuery,
							expenseSearchQuery: expenseSearchQuery,
							startYear: startDate.year(),
							startMonth: startDate.month() + 1,
							startDay: startDate.date(),
							endYear: endDate.year(),
							endMonth: endDate.month() + 1,
							endDay: endDate.date(),
							pageSize: 1000000,
							selectedSingleValue: selectedSingleValue,
							ignoreBaselineWinChance: !useWinProbability,
							excludeOpportunityActuals: true,
						},
						createCsvDownload: <ProjectPortfolioMonthByMonthProgramDownload />,
						startDate,
						endDate,
						boolEyeOptions,
						selectedSingleValue,
					});
				});
				return (
					<Table.Rows data={data} canExpand={true} loadMore={loadMore} autoload={true} {...levelProps}>
						{({rowData, tableColumnsProps, expanded, nextLevelProps}) => {
							const fixedPriceLocks = rowData?.project?.fixedPriceLocks;
							return (
								<>
									<ProjectPortfolioMonthByMonthRow
										rowData={rowData}
										tableColumnProps={tableColumnsProps}
										headerColumn={
											rowData.program.name
												? rowData.program.name
												: intl.formatMessage(
														{id: 'common.no_program'},
														{program: ProgramUtil.programText(intl.formatMessage)}
												  )
										}
										selectedSingleValue={selectedSingleValue}
										hasBaseline={hasBaseline}
										fixedPriceLocks={fixedPriceLocks}
										useWinProbability={useWinProbability}
									/>
									{expanded && (
										<ProjectPortfolioMonthByMonthProjectRows
											setCsvDownloadFunction={setCsvDownloadFunction}
											hasBaseline={hasBaseline}
											pageSize={pageSize}
											startDate={startDate}
											endDate={endDate}
											filters={filters}
											boolEyeOptions={boolEyeOptions}
											levelProps={nextLevelProps}
											timeSearchQuery={timeSearchQuery}
											expenseSearchQuery={expenseSearchQuery}
											selectedSingleValue={selectedSingleValue}
											programId={rowData.program.id}
											useWinProbability={useWinProbability}
										></ProjectPortfolioMonthByMonthProjectRows>
									)}
								</>
							);
						}}
					</Table.Rows>
				);
			}}
		</LoadMore>
	);
};

export default ProjectPortfolioMonthByMonthProgramRows;
